<!-- 404 -->
<template>
    <div class="errorPage">
        <img src="../assets/images/404.png" alt="">
    </div>
</template>
<script>
    import mixin from  '@/mixins/mixin'
    export default {
        mixins: [mixin],
        name: '',
        components: {

        },
        data(){
            return {

            }
        },
        mounted(){

        },
        methods:{

        }
    }
</script>
<style lang="less" scoped>
.errorPage {
    position: relative;
    height: calc(100% - 100px) !important;
    img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
}
</style>
